module.exports = __webpack_public_path__ + "img/ics_o_download_circle.492e097f.svg";